export const config = {
  filterName: {
    required: true,
    rules: [
      (value: string) => ({
        valid: !/[\\/*?":|<>]/g.test(value),
        'data-error': 'v_filterFormIllegalCharacters'
      }),
      (value: string) => ({
        valid: value.length <= 150,
        'data-error': 'v_filterNameTooLong'
      })
    ]
  },
};
